// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type='number'].form-control,
input[type='password'].form-control,
input[type='text'].form-control,
input[type='time'].form-control,
select {
  -webkit-appearance: none !important;
}
select.form-control,
textarea.form-control {
  border-radius: 0;
  border: 1px solid #ccc;
  outline: 0;
}

/* Added this rule in as our controls above do not allow for the correct error borders */
.has-error input[type='number'].form-control,
.has-error input[type='password'].form-control,
.has-error input[type='text'].form-control,
.has-error input[type='time'].form-control,
.has-error select.form-control,
.has-error textarea.form-control {
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  border-color: #a94442 !important;
}

/* Dropdown component */
.taModal.modal .selectContainer .fakeSelectElement {
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding-top: 6px;
  padding-bottom: 23px;
}

.taModal.modal .selectContainer .downArrow {
  height: 30px;
}

.taModal.modal .selectContainer .downArrow img {
  margin-top: 11px;
}

/* Locked input box */
.lockedInputField .icon {
  position: absolute;
  top: 31px;
  left: 28px;
  height: 20px;
  width: 20px;
  z-index: 2;
}
.lockedInputField input {
  padding-left: 40px;
}
.lockedInputField textarea {
  text-indent: 29px;
}
.lockedInputField .selectContainer .fakeSelectElement {
  padding-left: 4rem;
}
.form-control {
  height: 42px;
}

.checkbox + .checkbox,
.radio + .radio {
  margin: 0px 0px 10px;
}

.checkboxHolder input[type='checkbox'] {
  display: none;
  float: left;
}

.radio input[type='radio'] {
  opacity: 0;
  z-index: 1;
}

.checkbox input[type='checkbox'],
.radio input[type='radio'] {
  margin: 0px;
  position: relative;
}

.checkboxHolder label {
  cursor: pointer;
  display: inline;
  padding-left: 5px;
  position: relative;
  vertical-align: middle;
}

.checkboxHolder label::before {
  background-color: #fff;
  border: 1px solid #777;
  border-radius: 0px;
  content: '';
  cursor: pointer;
  display: inline-block;
  height: 12px;
  left: 0;
  margin-left: -20px;
  position: absolute;
  width: 12px;
  top: 1px;
}

.checkboxHolder label::after {
  display: inline-block;
  position: absolute;
  width: 16px;
  height: 16px;
  left: -2px;
  top: 0;
  margin-left: -20px;
  padding-left: 4px;
  padding-top: 0;
  font-size: 11px;
  color: #1eabe3;
}

.checkboxHolder input[type='checkbox']:checked + label:after {
  content: '\\2714';
  font-family: 'Rockwell', 'Times New Roman';
}

.radio {
  margin: 0px 0px 10px;
}

.radio label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-left: 5px;
}

.radio label::before {
  content: '';
  display: inline-block;
  position: absolute;
  width: 17px;
  height: 17px;
  left: 0;
  margin-left: -15px;
  border: 1px solid #777;
  border-radius: 50%;
  background-color: #fff;
  -webkit-transition: border 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out;
  transition: border 0.15s ease-in-out;
}

.radio label::after {
  display: inline-block;
  position: absolute;
  content: ' ';
  width: 11px;
  height: 11px;
  left: 3px;
  top: 3px;
  margin-left: -15px;
  border-radius: 50%;
  background-color: #555555;

  -webkit-transform: scale(0, 0);
  -ms-transform: scale(0, 0);
  -o-transform: scale(0, 0);
  transform: scale(0, 0);
}

.radio input[type='radio']:checked + label::after {
  -webkit-transform: scale(0.75, 0.75);
  -ms-transform: scale(0.75, 0.75);
  -o-transform: scale(0.75, 0.75);
  transform: scale(0.75, 0.75);
}

.radio input[type='radio']:checked + label::after {
  background-color: #1eabe3;
}

/* Styling for modal input box */
.modalInputBox {
  border: 1px solid black;
  padding-left: 0.5rem;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  margin-right: 3rem;
  width: 15rem;
  margin-bottom: 0.4rem;
}

/* The little arrow at the end of the select box */
.selectContainer {
  position: relative;
}

.selectContainer select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-left: 1rem;
  padding-bottom: 0.2rem;
  padding-top: 0.3rem;
  font-size: 14px;
}

/* This is for select boxes that have custom menues */
.selectContainer .fakeSelectElement {
  padding-left: 1rem;
  padding-bottom: 0.2rem;
  padding-top: 0.3rem;
  font-size: 14px;
  display: inline-block;
  border: 1px solid #c0c0c0;
  background-color: white;
  width: 100%;
  height: 2.5rem;
}

.fakeSelectElement.disabled {
  background-color: #eee;
}
.selectContainer .fakeSelectElement ~ .fakeSelectDropdown {
  position: absolute;
  top: 3rem;
  left: 0;
  height: 20rem;
  overflow-y: scroll;
  overflow-x: scroll;
  width: 50rem;
  background-color: white;

  padding-left: 2rem;
  padding-top: 1.5rem;

  -moz-box-shadow: 2px 2px 8px 1px #adadad;
  -webkit-box-shadow: 2px 2px 8px 1px #adadad;
  box-shadow: 2px 2px 8px 1px #adadad;
  z-index: 1;
}

.selectContainer .fakeSelectElement ~ .fakeSelectDropdown .fakeSelectItem {
  display: block;
  margin-bottom: 1.5rem;
}

.selectContainer select::-ms-expand {
  display: none;
}

.selectContainer .downArrow {
  position: absolute;
  right: 0;
  top: 0;
  border-left: 1px solid black;
  pointer-events: none;
  height: 1.8rem;
  margin-top: 4px;
}

.selectContainer img {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 8px;
  margin-left: 7px;
}

/* Autocomplete stuff */
.autocompleteBox {
  background-color: white;
  z-index: 1;
  padding-left: 2rem;
  padding-top: 0.5rem;
}

.autocompleteBox .result {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/forms.css"],"names":[],"mappings":"AAAA;;;;;EAKE,mCAAmC;AACrC;AACA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;;AAEA,wFAAwF;AACxF;;;;;;EAME,wDAAwD;EACxD,gDAAgD;EAChD,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,MAAM;EACN,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;EAC5C,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;;EAEzB,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;;EAEvB,kBAAkB;EAClB,mBAAmB;;EAEnB,wCAAwC;EACxC,2CAA2C;EAC3C,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,4BAA4B;EAC5B,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["input[type='number'].form-control,\ninput[type='password'].form-control,\ninput[type='text'].form-control,\ninput[type='time'].form-control,\nselect {\n  -webkit-appearance: none !important;\n}\nselect.form-control,\ntextarea.form-control {\n  border-radius: 0;\n  border: 1px solid #ccc;\n  outline: 0;\n}\n\n/* Added this rule in as our controls above do not allow for the correct error borders */\n.has-error input[type='number'].form-control,\n.has-error input[type='password'].form-control,\n.has-error input[type='text'].form-control,\n.has-error input[type='time'].form-control,\n.has-error select.form-control,\n.has-error textarea.form-control {\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  border-color: #a94442 !important;\n}\n\n/* Dropdown component */\n.taModal.modal .selectContainer .fakeSelectElement {\n  border-radius: 2px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  padding-top: 6px;\n  padding-bottom: 23px;\n}\n\n.taModal.modal .selectContainer .downArrow {\n  height: 30px;\n}\n\n.taModal.modal .selectContainer .downArrow img {\n  margin-top: 11px;\n}\n\n/* Locked input box */\n.lockedInputField .icon {\n  position: absolute;\n  top: 31px;\n  left: 28px;\n  height: 20px;\n  width: 20px;\n  z-index: 2;\n}\n.lockedInputField input {\n  padding-left: 40px;\n}\n.lockedInputField textarea {\n  text-indent: 29px;\n}\n.lockedInputField .selectContainer .fakeSelectElement {\n  padding-left: 4rem;\n}\n.form-control {\n  height: 42px;\n}\n\n.checkbox + .checkbox,\n.radio + .radio {\n  margin: 0px 0px 10px;\n}\n\n.checkboxHolder input[type='checkbox'] {\n  display: none;\n  float: left;\n}\n\n.radio input[type='radio'] {\n  opacity: 0;\n  z-index: 1;\n}\n\n.checkbox input[type='checkbox'],\n.radio input[type='radio'] {\n  margin: 0px;\n  position: relative;\n}\n\n.checkboxHolder label {\n  cursor: pointer;\n  display: inline;\n  padding-left: 5px;\n  position: relative;\n  vertical-align: middle;\n}\n\n.checkboxHolder label::before {\n  background-color: #fff;\n  border: 1px solid #777;\n  border-radius: 0px;\n  content: '';\n  cursor: pointer;\n  display: inline-block;\n  height: 12px;\n  left: 0;\n  margin-left: -20px;\n  position: absolute;\n  width: 12px;\n  top: 1px;\n}\n\n.checkboxHolder label::after {\n  display: inline-block;\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  left: -2px;\n  top: 0;\n  margin-left: -20px;\n  padding-left: 4px;\n  padding-top: 0;\n  font-size: 11px;\n  color: #1eabe3;\n}\n\n.checkboxHolder input[type='checkbox']:checked + label:after {\n  content: '\\2714';\n  font-family: 'Rockwell', 'Times New Roman';\n}\n\n.radio {\n  margin: 0px 0px 10px;\n}\n\n.radio label {\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  padding-left: 5px;\n}\n\n.radio label::before {\n  content: '';\n  display: inline-block;\n  position: absolute;\n  width: 17px;\n  height: 17px;\n  left: 0;\n  margin-left: -15px;\n  border: 1px solid #777;\n  border-radius: 50%;\n  background-color: #fff;\n  -webkit-transition: border 0.15s ease-in-out;\n  -o-transition: border 0.15s ease-in-out;\n  transition: border 0.15s ease-in-out;\n}\n\n.radio label::after {\n  display: inline-block;\n  position: absolute;\n  content: ' ';\n  width: 11px;\n  height: 11px;\n  left: 3px;\n  top: 3px;\n  margin-left: -15px;\n  border-radius: 50%;\n  background-color: #555555;\n\n  -webkit-transform: scale(0, 0);\n  -ms-transform: scale(0, 0);\n  -o-transform: scale(0, 0);\n  transform: scale(0, 0);\n}\n\n.radio input[type='radio']:checked + label::after {\n  -webkit-transform: scale(0.75, 0.75);\n  -ms-transform: scale(0.75, 0.75);\n  -o-transform: scale(0.75, 0.75);\n  transform: scale(0.75, 0.75);\n}\n\n.radio input[type='radio']:checked + label::after {\n  background-color: #1eabe3;\n}\n\n/* Styling for modal input box */\n.modalInputBox {\n  border: 1px solid black;\n  padding-left: 0.5rem;\n  padding-top: 0.2rem;\n  padding-bottom: 0.2rem;\n  margin-right: 3rem;\n  width: 15rem;\n  margin-bottom: 0.4rem;\n}\n\n/* The little arrow at the end of the select box */\n.selectContainer {\n  position: relative;\n}\n\n.selectContainer select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  padding-left: 1rem;\n  padding-bottom: 0.2rem;\n  padding-top: 0.3rem;\n  font-size: 14px;\n}\n\n/* This is for select boxes that have custom menues */\n.selectContainer .fakeSelectElement {\n  padding-left: 1rem;\n  padding-bottom: 0.2rem;\n  padding-top: 0.3rem;\n  font-size: 14px;\n  display: inline-block;\n  border: 1px solid #c0c0c0;\n  background-color: white;\n  width: 100%;\n  height: 2.5rem;\n}\n\n.fakeSelectElement.disabled {\n  background-color: #eee;\n}\n.selectContainer .fakeSelectElement ~ .fakeSelectDropdown {\n  position: absolute;\n  top: 3rem;\n  left: 0;\n  height: 20rem;\n  overflow-y: scroll;\n  overflow-x: scroll;\n  width: 50rem;\n  background-color: white;\n\n  padding-left: 2rem;\n  padding-top: 1.5rem;\n\n  -moz-box-shadow: 2px 2px 8px 1px #adadad;\n  -webkit-box-shadow: 2px 2px 8px 1px #adadad;\n  box-shadow: 2px 2px 8px 1px #adadad;\n  z-index: 1;\n}\n\n.selectContainer .fakeSelectElement ~ .fakeSelectDropdown .fakeSelectItem {\n  display: block;\n  margin-bottom: 1.5rem;\n}\n\n.selectContainer select::-ms-expand {\n  display: none;\n}\n\n.selectContainer .downArrow {\n  position: absolute;\n  right: 0;\n  top: 0;\n  border-left: 1px solid black;\n  pointer-events: none;\n  height: 1.8rem;\n  margin-top: 4px;\n}\n\n.selectContainer img {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0;\n  margin-right: 8px;\n  margin-left: 7px;\n}\n\n/* Autocomplete stuff */\n.autocompleteBox {\n  background-color: white;\n  z-index: 1;\n  padding-left: 2rem;\n  padding-top: 0.5rem;\n}\n\n.autocompleteBox .result {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
